// ///////////////////////////////////////////////////////////
// tbMath: The engine part dealing mathematical calculations
//		It contains classes dealing with vectors, bounding boxes
//		random number, etc.
//
// Copyright 2013-2015 CoolGames
// Last Changed: 08-06-2015
// ///////////////////////////////////////////////////////////
var TBMath = function () {
    "use strict";
};
TBMath.prototype.degToRad = function (degrees) {
    "use strict";
    return Math.PI * degrees / 180;
};
TBMath.prototype.radToDeg = function (rad) {
    "use strict";
    return 180 * rad / Math.PI;
};
TBMath.prototype.distance = function (x1, y1, x2, y2) {
    "use strict";
    return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
};
TBMath.prototype.direction = function (x1, y1, x2, y2) {
    "use strict";
    var xx = x2 - x1, yy = y2 - y1;
    return tbMath.radToDeg(Math.atan2(-yy, xx));
};
TBMath.prototype.projectionX = function (direction, length) {
    "use strict";
    return length * Math.cos(tbMath.degToRad(direction));
};
TBMath.prototype.projectionY = function (direction, length) {
    "use strict";
    return -length * Math.sin(tbMath.degToRad(direction));
};
export var tbMath = new TBMath();
